import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CORE_CONFIG_TOKEN } from '@ndk/ng-core/component/core.config';
import { Observable } from 'rxjs';

import { ICoreConfigInternal } from '@core/core.config.model';

import { IHelpMenuModel } from './help-menu.model';

@Injectable()
export class HelpMenuService {
    private apiUrl: string;

    constructor(
        @Inject(CORE_CONFIG_TOKEN) config: ICoreConfigInternal,
        private http: HttpClient,
    ) {
        this.apiUrl = `${ config.apiEndpoint }api/manual`;
    }

    public getManualUrls(): Observable<IHelpMenuModel> {
        return this.http.get<IHelpMenuModel>(`${ this.apiUrl }/urls`);
    }
}
